import * as vp from 'vopay';
import { useTranslation } from 'react-i18next';
import { FileUploadForm } from './types';

type FileUploadRow = {
  label: string;
  id: vp.FileUploadId;
  idFileName?: vp.FileUploadId;
  require: boolean;
  visible: (ctx: FileUploadForm) => boolean;
  getSelectOptions: () => { [key: string]: string };
  type: 'input' | 'select' | 'textarea' | 'inputfile';
  preset: keyof vp.TextFieldPresets | undefined;
};
const ProductOptions: { [key: string]: string } = {
  EFT: 'EFT',
  'e-Transfer': 'e-Transfer',
};
const ProductOptionsUs: { [key: string]: string } = {
  ACH: 'ACH',
};
const ServiceOptions: { [key: string]: string } = {
  Debit: 'Debit (Collect Funds)',
  Credit: 'Credit (Send Funds)',
};

export const buildFileUploadRows = (Country: string): FileUploadRow[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'Contacts.FileUpload.Form' });

  return [
    {
      label: t('product', { defaultValue: 'Product' }),
      id: vp.FileUploadId.Product,
      require: true,
      preset: 'text',
      getSelectOptions: () => (Country === 'US' ? ProductOptionsUs : ProductOptions),
      type: 'select',
      visible: () => true,
    },
    {
      label: t('service', { defaultValue: 'Service' }),
      id: vp.FileUploadId.Service,
      require: true,
      preset: 'text',
      getSelectOptions: () => ServiceOptions,
      type: 'select',
      visible: () => false,
    },
    {
      label: t('currency', { defaultValue: 'Choose Currency' }),
      id: vp.FileUploadId.Currency,
      require: true,
      preset: 'text',
      getSelectOptions: () => (Country === 'US' ? vp.US_CURRENCY_ONLY : vp.CA_CURRENCY_ONLY),
      type: 'select',
      visible: () => false,
    },
    {
      label: t('file', { defaultValue: 'File' }),
      id: vp.FileUploadId.FileBase64,
      idFileName: vp.FileUploadId.FileName,
      require: true,
      preset: 'text',
      getSelectOptions: () => vp.CA_CURRENCY_ONLY,
      type: 'inputfile',
      visible: () => true,
    },
  ];
};
